









import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'RecordGroupCampusReportAction',
  components: {
  },
})
export default class PriorityClazzCourseGroupCampusReportAction extends Vue {
  /** bus */
  @Prop()
  private bus: Vue;
}
